<template>
	<div>
	<h5>{{$t('routine_analyses.pests_activity_devices')}}</h5>
		<div>
			<div class="row">
			<div class="col s2 hiddenprint">{{$t('routine_analyses.order')}}:</div>
			<div class="col s6"><select v-model="orderby">
				<option value="number">{{$t('routine_analyses.by_device_number')}}</option>
				<option value="conditions_asc">{{$t('routine_analyses.from_the_lowest_activity')}}</option>
				<option value="conditions_desc">{{$t('routine_analyses.from_the_highest_activity')}}</option>
			</select>
			</div>
			</div>
		<col-chart-inspections-quantities :devices="devices" :properties="properties" :color="color" :orderby='orderby' :pest_id="pest_id"/>
	</div>
	</div>
</template>
<script>
export default {
	data: function () {
	    return {
	    	orderby: 'number'
	    }
	},
	props: {
        properties: Object,
        devices: Object,
        color: String,
        pest_id: String
    },
}
</script>
<style scoped></style>
